import { Check } from "lucide-react";

const usps = [
  "Zuverlässig & pünktlich",
  "Schnelle Termine",
  "Faire & transparente Preise",
  "Alles aus einer Hand",
  "Persönlicher Service",
];

export const UspBar = () => {
  return (
    <div className="bg-primary-dark">
      <div className="container-narrow">
        <ul className="flex min-h-[72px] snap-x snap-mandatory items-center gap-6 overflow-x-auto py-4 md:justify-between md:gap-2 md:overflow-visible">
          {usps.map((u, i) => (
            <li
              key={u}
              className="flex shrink-0 snap-start items-center gap-2 px-2 text-white md:flex-1 md:justify-center md:border-r md:border-white/10 md:last:border-0"
              style={{ fontSize: 14, fontWeight: 500 }}
            >
              <Check className="h-4 w-4 text-accent" strokeWidth={3} />
              <span>{u}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
